import { render, staticRenderFns } from "./SBSearchableHealthLibrary.vue?vue&type=template&id=d7c2ccce&scoped=true"
import script from "./SBSearchableHealthLibrary.vue?vue&type=script&lang=js"
export * from "./SBSearchableHealthLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c2ccce",
  null
  
)

export default component.exports